module.exports = __webpack_public_path__ + "static/media/gongfu.1363b2e4.png";